import { WRTCServer } from '@/types/admin'
import { computed } from '@vue/composition-api'

const useDecomposedWRTCServer = (server: WRTCServer) => {
  const url = computed(() => server.url)
  const enabled = computed(() => server.enabled)

  return {
    url,
    enabled
  }
}

export default useDecomposedWRTCServer
